@if (data$ | async; as data) { @if (show) {
<div class="tc-acceptance-container">
  <mat-checkbox [disableRipple]="true" (change)="onChecked($event)" [color]="'primary'">
    <!-- {{ data.content }} -->
    {{ 'termsConditions.readTerms' | cxTranslate }}
    <a href="#">{{ 'termsConditions.termsConditionsLabel' | cxTranslate }}</a>
  </mat-checkbox>
  <div class="tc-acceptance-button">
    <button
      mat-button
      class="primary-btn"
      [class.disabled]="isDisabled"
      [disabled]="isDisabled"
      (click)="acceptTerms()"
    >
      {{ 'termsConditions.acceptButton' | cxTranslate }}
    </button>
    <button
      mat-button
      class="secondary-btn"
      [routerLink]="
        {
          cxRoute: 'logout'
        } | cxUrl
      "
    >
      {{ 'termsConditions.declineButton' | cxTranslate }}
    </button>
  </div>
</div>
} }
